/* eslint-disable react/no-array-index-key */
import React, {
  lazy,
  Suspense,
  Fragment
} from 'react';
import {
  Switch,
  Redirect,
  Route
} from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import LoadingScreen from 'src/components/LoadingScreen';
import GuestGuard from 'src/components/GuestGuard';

const routesConfig = [
  {
    exact: true,
    path: '/',
    component: () => <Redirect to="/app" />
  },
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/pages/Error404View'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    path: '/login-unprotected',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/register',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    exact: true,
    path: '/register-unprotected',
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    path: '/app',
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/app',
        component: lazy(() => import('src/views/reports/DashboardView'))
      },
      {
        exact: true,
        path: '/app/subreddit',
        component: lazy(() => import('src/views/subreddit/QueryListView'))
      },
      {
        exact: true,
        path: '/app/subreddit/search',
        component: lazy(() => import('src/views/subreddit/SearchView'))
      },
      {
        exact: true,
        path: '/app/subreddit/:reportId',
        component: lazy(() => import('src/views/subreddit/ReportView'))
      },
      {
        exact: true,
        path: '/app/reddit_new',
        component: lazy(() => import('src/views/reddit/StaticQueryListView'))
      },
      {
        exact: true,
        path: '/app/reddit_new/:reportId',
        component: lazy(() => import('src/views/reddit/StaticReportView'))
      },
      {
        exact: true,
        path: '/app/reddit',
        component: lazy(() => import('src/views/reddit/QueryListView'))
      },
      {
        exact: true,
        path: '/app/reddit/search',
        component: lazy(() => import('src/views/reddit/SearchView'))
      },
      {
        exact: true,
        path: '/app/reddit/:reportId',
        component: lazy(() => import('src/views/reddit/ReportView'))
      },
      {
        exact: true,
        path: '/app/stack',
        component: lazy(() => import('src/views/stack/QueryListView'))
      },
      {
        exact: true,
        path: '/app/stack/search',
        component: lazy(() => import('src/views/stack/SearchView'))
      },
      {
        exact: true,
        path: '/app/stack/:reportId',
        component: lazy(() => import('src/views/stack/ReportView'))
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
];

const renderRoutes = (routes) => (routes ? (
  <Suspense fallback={<LoadingScreen />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Component = route.component;

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard>
                <Layout>
                  {route.routes
                    ? renderRoutes(route.routes)
                    : <Component {...props} />}
                </Layout>
              </Guard>
            )}
          />
        );
      })}
    </Switch>
  </Suspense>
) : null);

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
